import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate, isNullOrEmpty, newObj } from '../../../../../utils/util';
import { getVision } from '../../../../../services/auth';
import { VISIONS, ENUMS } from '../../../../../utils/constants';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import { Select, Breadcrumbs } from '../../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../../services/LinePickingService';
import { validateInputsRequired } from '../../../../../utils/handleChangeHooks';

const SmallPartsFilterByRouteAndQueue = (props) => {
    const [arrayDropRoute, setArrayDropRoute] = useState([]);
    const [filterRoutes, setFilterRoutes] = useState({ routes: [] });
    const [arrayDropQueue, setArrayDropQueue] = useState([]);
    const [filterQueue, setFilterQueue] = useState({ position: [] });

    useEffect(() => {
        let area = props.areas.find(f => f.code === props.user.unit);
        const filterObj = newObj(props.filterOrder);
        filterObj.sectors = props.sectors;
        filterObj.almox = undefined;
        filterObj.orderType = ENUMS.eOrderType.LinePicking.value;

        if (area) {
            filterObj.areaRouteAreaId = area.unitId;
        }

        resetRoutes(filterObj);
        resetPosition(filterObj);
        filterObj.routeType = ENUMS.eRouteType.LinePicking.value;
        props.getRoutes(filterObj, (data) => {
            var drop = data.map((i) => {
                return { id: i, text: i };
            });

            const sortedDrop = drop.sort((a, b) => {
                if (a.text < b.text) { return -1; }
                if (a.text > b.text) { return 1; }
                return 0;
            });

            setArrayDropRoute(sortedDrop);
        });
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (filterRoutes.routes.length > 0) {
            const filterObj = newObj(props.filterOrder);
            filterObj.sectors = props.sectors;
            filterObj.almox = undefined;
            filterObj.showInFilterQueue = false;
            filterObj.orderType = ENUMS.eOrderType.LinePicking.value;
            filterObj.routes = filterRoutes.routes;
            resetPosition(filterObj);
            props.getQueues(filterObj, (data) => {
                var drop = data.map((i) => {
                    return { id: i, text: i };
                });

                const sortedDrop = drop.sort((a, b) => {
                    if (a.text < b.text) { return -1; }
                    if (a.text > b.text) { return 1; }
                    return 0;
                });

                setArrayDropQueue(sortedDrop);
            });

        }
        // eslint-disable-next-line
    }, [filterRoutes]);

    const resetRoutes = (filterObj) => {
        filterObj.routes = [];
        filterObj.showInFilterQueue = false;
    }

    const resetPosition = (filterObj) => {
        filterObj.position = [];
        filterObj.showInFilterQueue = false;
    }

    const addQueueAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filterQueue);
            finalFilter.position.push(item)
            setFilterQueue(finalFilter);
        }
    };

    const addQueueFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filterQueue);
            finalFilter.position = Array.from(selectedOptions).map(x => x.value)
            setFilterQueue(finalFilter);
        }
    };


    const applyFilter = () => {

        if (validateInputsRequired('formFilter')) {
            let filterRouteAssign = false;
            let filterRouteOnDemandAssign = false;
            let filterQueueAssign = false;

            if (!isNullOrEmpty(filterQueue.position) && filterQueue.position.length > 0) {
                props.filterOrder.position = filterQueue.position;
                props.filterOrder.orderType = ENUMS.eOrderType.LinePicking.value;
                props.filterOrder.excludeOrderGrouped = true;
                props.filterOrder.allOrders = true;
                props.filterOrder.assigned = false;
                props.filterOrder.sectors = props.sectors;
                props.setFilterOrder(props.filterOrder);

                filterQueueAssign = true;
            }

            if (filterRoutes.routes.length > 0) {
                props.filter.routes = filterRoutes.routes;
                props.filter.dynamicFlow = false;
                if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
                    props.filter.orderType = ENUMS.eOrderType.LinePicking.value;
                    props.filter.excludeOrderGrouped = true;
                    props.filter.unitOrderingId = props.areas.find((a) => a.code === props.almox)?.unitOrderingId;
                    props.filter.sectors = props.sectors;
                    props.filter.allOrders = true;
                    props.setFilterOrder(props.filter);

                    filterRouteAssign = true;
                }
                else {
                    var obj = {};
                    Object.assign(obj, props.filter);
                    obj.unitOrderingId = props.areas.find((a) => a.code === props.almox)?.unitOrderingId;
                    props.setFilterOrder(obj);
                }
            }

            if (!filterRouteOnDemandAssign && !filterRouteAssign && filterQueueAssign) {
                var filterR = newObj(props.filter)
                resetRoutes(filterR)
                props.setFilterOrder(filterR);
            }

            if ((filterRouteOnDemandAssign || filterRouteAssign) && !filterQueueAssign) {
                var filterQ = newObj(props.filter)
                resetPosition(filterQ)
                props.setFilterOrder(filterQ);
            }

            if (filterRouteOnDemandAssign) {
                // Redirect para tela de Orders
                props.history.push({
                    state: {
                        filterRoute: true
                    },
                    pathname: '../onDemand'
                });
            }

            if (filterQueueAssign || filterRouteAssign) {
                // Redirect para tela de Orders
                props.history.push({
                    pathname: '../orders',
                    state: {
                        printerLabel: true,
                        kanban: true
                    }
                });
            }
        }
    };


    const subtitlesSmallPartsFilterByRouteAndQueue = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filterByRouteAndQueue') }];
    }


    const addRouteAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filterRoutes);
            finalFilter.routes.push(item)
            setFilterRoutes(finalFilter);
        }
    };

    const addRouteFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filterRoutes);
            finalFilter.routes = Array.from(selectedOptions).map(x => x.value)
            setFilterRoutes(finalFilter);
        }
    };

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesSmallPartsFilterByRouteAndQueue()} />
            <div id="formFilter" className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12">
                        <div className="input-field no-padding col s12">
                            <Select
                                required
                                id="route"
                                label={translate('line-picking:linepicking.route')}
                                name="route"
                                display="description"
                                change={addRouteFilter}
                                multiple={true}
                                changeAll={addRouteAll}
                                placeHolder={translate('general:choose-one-option')}
                                disablePlaceHoderSelect={true}
                                data={arrayDropRoute}
                                clearAll={() => {
                                    setFilterRoutes({ routes: [] });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12">
                            <div className="input-field no-padding col s12">
                                <Select
                                    required
                                    id="queue"
                                    label={translate('line-picking:linepicking.queue')}
                                    name="queue"
                                    display="description"
                                    change={addQueueFilter}
                                    multiple={true}
                                    changeAll={addQueueAll}
                                    placeHolder={translate('general:choose-one-option')}
                                    disablePlaceHoderSelect={true}
                                    data={arrayDropQueue}
                                    clearAll={() => {
                                        setFilterQueue({ position: [] });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        sectors: state.linePickingReducer.sectors,
        routes: state.pickingReducer.routes,
        almox: state.linePickingReducer.almox,
        areas: state.linePickingReducer.areas,
        filterOrder: state.linePickingReducer.filter,
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        },
        getRoutes: (filter, callback) => {
            dispatch(LinePickingService.getRoutes(filter, callback));
        },
        getQueues: (filter, callback) => {
            dispatch(LinePickingService.getQueues(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByRouteAndQueue)));
